import Link from 'next/link';
import { useCallback, useMemo } from 'react';
import * as yup from 'yup';
import styles from './GetEds.module.scss';

export const GetEds = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Как получить электронную подпись (ЭП)</h1>
                <p className={styles.textLarge}>
                    Теперь Вы можете заказать квалифицированную электронную
                    подпись (ЭП) удаленно, без посещения нашего офиса, находясь
                    в любом регионе России, следующим образом: выбираете тариф,
                    загружаете документы, оплачиваете счет и после прохождения
                    верификации в ближайшей точке выдачи получаете электронную
                    подпись. Мы думаем о клиентах и ценим Ваше время, поэтому
                    получение ЭП у нас происходит через партнерский
                    удостоверяющий центр быстро и удобно. Подробная информация
                    на сайте
                    <a
                        href="https://1554.iitrust.lk"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                    >
                        {' 1554.iitrust.lk '}
                    </a>
                    <br />
                    или по телефонам
                    <a href="tel:+78002500265">{' 8-800-250-02-65 '}</a>;&nbsp;
                    <a href="tel:+78005552083">{' 8-800-555-20-83 '}</a>.
                </p>
                <hr />
                <p className={styles.textSmall}>
                    <strong>Примечание.</strong>
                    Для работы на нашей площадке подходит{' '}
                    <strong>
                        {' '}
                        усиленная квалифицированная
                        <br />
                        электронная подпись (ЭП)
                    </strong>
                    , выданная аккредитованным Удостоверяющим центром. <br />
                    Согласно изменениям ФЗ-63 сертификат{' '}
                    <i>руководителя ЮЛ или ИП</i> <br />с 01.01.2022 можно
                    получить только через <i>государственные УЦ.</i>
                </p>
            </div>
        </div>
    );
};
